export const COMMIT_ID = 'unset';
export const BUILD_TIME = 'unset';
